"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CategoryLinks = void 0;
exports.hasCategoryLinks = hasCategoryLinks;
var config_1 = require("../config");
var get_closest_1 = require("../helper/get-closest");
var CategoryLinks = /*#__PURE__*/function () {
  function CategoryLinks() {
    var _this = this;
    _classCallCheck(this, CategoryLinks);
    this.categoryLinksWrapper = null;
    this.toggleCategoryLinksButton = null;
    this.href = null;
    this.toggleCategoryLinksButton = document.querySelector(config_1.CONFIG.categoryLinks.toggleButton);
    this.categoryLinksWrapper = document.querySelector(config_1.CONFIG.categoryLinks.main);
    this.categoryLinkButtons = document.querySelectorAll(config_1.CONFIG.categoryLinks.toggleCategoryLinkButton);
    this.toggleCategoryLinksButton.addEventListener('click', this.toggleCategoryLinks.bind(this));
    if (this.categoryLinkButtons.length > 0) {
      [].forEach.call(this.categoryLinkButtons, function (button) {
        button.addEventListener('click', _this.toggleCategoryLink.bind(_this));
      });
    }
  }
  return _createClass(CategoryLinks, [{
    key: "toggleCategoryLinks",
    value: function toggleCategoryLinks(event) {
      event.preventDefault();
      if (this.categoryLinksWrapper.classList.contains(config_1.CONFIG.categoryLinks.activeClass)) {
        this.categoryLinksWrapper.classList.remove(config_1.CONFIG.categoryLinks.activeClass);
      } else {
        this.categoryLinksWrapper.classList.add(config_1.CONFIG.categoryLinks.activeClass);
      }
    }
  }, {
    key: "toggleCategoryLink",
    value: function toggleCategoryLink(event) {
      event.preventDefault();
      var button = (0, get_closest_1.getClosest)(config_1.CONFIG.categoryLinks.toggleCategoryLinkButton, event.target);
      if (this.categoryLinksWrapper.classList.contains(config_1.CONFIG.categoryLinks.activeClass)) {
        this.categoryLinksWrapper.classList.remove(config_1.CONFIG.categoryLinks.activeClass);
      }
      window.location.href = button.getAttribute('href');
    }
  }]);
}();
exports.CategoryLinks = CategoryLinks;
function hasCategoryLinks() {
  if (document.querySelector(config_1.CONFIG.categoryLinks.main)) {
    return true;
  }
  return false;
}